export var isString = function isString(value) {
    return typeof value === 'string' || value instanceof String;
};

export var contains = function contains(array, value) {
    return array && array.indexOf(value) !== -1;
};

export var stripLeadingText = function stripLeadingText(string, leadingText) {
    if (isString(string) && string.startsWith(leadingText)) {
        return string.slice(1);
    }
    return string;
};

export var hex2string = function hex2string(hex) {
    var str = '';
    for (var i = 0; i < hex.length; i += 2) {
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return str;
};

export var getQueryParams = function getQueryParams(url) {
    if (!url.includes('?')) {
        return url;
    }

    var urlArray = url.split('?');
    if (urlArray[1] !== undefined) {
        return urlArray[1];
    }
    return false;
};

export var getCookieValue = function getCookieValue(cookieName) {
    var name = cookieName + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i += 1) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
};